import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'

const resetPasswordRouteSchema = z.object({
  customer_id: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  user_id: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  digest: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  validateSearch: resetPasswordRouteSchema,
}).lazy(() => import('./resetPassword').then((d) => d.Route))

export type ResetPasswordRouteSearchParams = z.infer<typeof resetPasswordRouteSchema>
